import { render, staticRenderFns } from "./TopNewsBanner.vue?vue&type=template&id=038318d1&scoped=true&"
import script from "./TopNewsBanner.vue?vue&type=script&lang=js&"
export * from "./TopNewsBanner.vue?vue&type=script&lang=js&"
import style0 from "./TopNewsBanner.vue?vue&type=style&index=0&id=038318d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038318d1",
  null
  
)

export default component.exports